import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './features/app/components/App.web';
import { getLogger } from './features/base/logging/functions';
import Platform from './features/base/react/Platform.web';
import { getJitsiMeetGlobalNS, getJitsiMeetGlobalNSConnectionTimes } from './features/base/util/helpers';
import DialInSummaryApp from './features/invite/components/dial-in-summary/web/DialInSummaryApp';
import PrejoinApp from './features/prejoin/components/web/PrejoinApp';
import WhiteboardApp from './features/whiteboard/components/web/WhiteboardApp';
import VisioGateApp from './features/visio-gate/VisioGateApp';

const logger = getLogger('app:index.web');

// Logs globaux
window.addEventListener('error', ev => {
  logger.error(
    `UnhandledError: ${ev.message}`,
    `Script: ${ev.filename}`,
    'StackTrace: ',
    ev.error?.stack
  );
});

window.addEventListener('unhandledrejection', ev => {
  logger.error(
    `UnhandledPromiseRejection: ${ev.reason}`,
    'StackTrace: ',
    ev.reason && ev.reason.stack
  );
});

// iOS BFCache workaround
if (Platform.OS === 'ios') {
  window.addEventListener('pageshow', event => {
    if (event.persisted) {
      window.location.reload();
    }
  });
}

const globalNS = getJitsiMeetGlobalNS();

globalNS.hasLoaded = false;

window.addEventListener('load', () => {
  globalNS.hasLoaded = true;
});

globalNS.entryPoints = {
  APP: App,
  VISIO_GATE: VisioGateApp,
  PREJOIN: PrejoinApp,
  DIALIN: DialInSummaryApp,
  WHITEBOARD: WhiteboardApp
};

globalNS.renderEntryPoint = ({ Component, props = {}, elementId = 'react' }) => {
  /* eslint-disable-next-line react/no-deprecated */
  ReactDOM.render(
    <Component { ...props } />,
    document.getElementById(elementId)
  );
};